export default {"src":"/evde-internet/_next/static/media/networktower.5578f1e0.svg","height":48,"width":48};